import { useTranslation } from "react-i18next";
import { useGetPsTreeDiff } from "../../../../../api/ps-trees/ps-trees";
import { useDefaultOptions } from "../../../../../hooks/api";
import ErrorComponent from "../../../../atoms/ErrorComponent";
import PsTree, { PsTreePsTreeGetterCommonProps } from "./PsTree";

interface Props extends PsTreePsTreeGetterCommonProps {
  /** 旧バージョンの PS バージョン ID。 */
  olderPsVersionId: number;
  /** 新バージョンの PS バージョン ID。 */
  newerPsVersionId: number;
}

/** PS 比較画面の PS ツリー用データの取得コンポーネント。 */
function PsDiffTreeGetter(
  {
    olderPsVersionId,
    newerPsVersionId,
    ...props
  }: Props
) {
  // i18n 用。
  const {
    // t,
    i18n,
  } = useTranslation();

  const defaultOptions = useDefaultOptions(i18n.language);

  // PS ツリー差分情報取得 API。
  const getPsTreeDiffResponse = useGetPsTreeDiff(
    olderPsVersionId,
    newerPsVersionId,
    defaultOptions
  );

  if (getPsTreeDiffResponse.isError) {
    return (
      <div id="product-side-list">
        <ErrorComponent error={getPsTreeDiffResponse.error} />
      </div>
    );
  }

  // 差分が存在するPSのPSIDリスト(PSツリー比較用)を作成
  const diffPsIds : number[] = [...getPsTreeDiffResponse.data?.data.AddDelPsIds ?? [], ...(getPsTreeDiffResponse.data?.data.MovePsIds ?? [])];

  return props.mode === 'DiffTree' ?
  (
    <>
      <PsTree
        rootPsTreeItem={getPsTreeDiffResponse.data?.data.PsTreeItemSrc}
        selectedPsVersionId={olderPsVersionId}
        diffPsIds={diffPsIds}
        {...props}
      />
      <PsTree
        rootPsTreeItem={getPsTreeDiffResponse.data?.data.PsTreeItemDst}
        selectedPsVersionId={newerPsVersionId}
        diffPsIds={diffPsIds}
        {...props}
        mode="DiffTreeView"
      />
    </>
  ) : (
      <PsTree
        rootPsTreeItem={getPsTreeDiffResponse.data?.data.PsTreeItemDst}
        selectedPsVersionId={newerPsVersionId > 0 ? newerPsVersionId : olderPsVersionId}
        diffPsIds={diffPsIds}
        {...props}
      />
  );
}

export default PsDiffTreeGetter;